"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/taggedTemplateLiteral"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _IFrameRenderer = _interopRequireDefault(require("../../components/elements/IFrameRenderer/IFrameRenderer"));
var _bfBaseStyles = require("@bestfit-team/bf-base-styles");
var _HtmlStringVariable = _interopRequireDefault(require("./HtmlStringVariable"));
var _excluded = ["formCode"];
var _templateObject;
var StyledIframe = (0, _styledComponents.default)(_IFrameRenderer.default)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  .iframeHolder {\n    iframe {\n      overflow: hidden !important;\n\n    }\n  }\n  iframe {\n      overflow: hidden !important;\n  }\n\n  @media (min-width: ", ") {\n    width: 350px !important;\n    height: 615px;\n  }\n  \n  @media (min-width: ", ") {\n    width: 525px !important;\n  }\n\n  @media (min-width: ", ") {\n    width: 750px !important;\n    height: 350px !important;\n  }\n"])), _bfBaseStyles.Breakpoints.xs, _bfBaseStyles.Breakpoints.s, _bfBaseStyles.Breakpoints.m);
var FooterSubscribeForm = function FooterSubscribeForm(_ref) {
  var formCode = _ref.formCode,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement(StyledIframe, Object.assign({
    content: _HtmlStringVariable.default,
    title: 'Subscribe Form'
  }, props)));
};
var _default = FooterSubscribeForm;
exports.default = _default;